// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var CsatDefaultForm$ReactHooksTemplate = require("./CsatDefaultForm.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");

function CsatForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var csat = props.csat;
  var match = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(CsatDefaultForm$ReactHooksTemplate.make, {
                  csat: csat,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: Csat$ReactHooksTemplate.getTextTranslation(csat, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: Csat$ReactHooksTemplate.getDescriptionTranslation(csat, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(Belt_List.mapWithIndex(Csat$ReactHooksTemplate.answerTypeCollection(csat), (function (id, xs) {
                                  var code = Csat$ReactHooksTemplate.answerTypeToUnicode(xs);
                                  var match = Csat$ReactHooksTemplate.answered(csat);
                                  var match$1 = Csat$ReactHooksTemplate.getAnswer(csat);
                                  var match$2 = match && match$1 !== undefined && xs === match$1 ? [
                                      "text-6xl small:text-5xl",
                                      "pulse",
                                      "text-sm",
                                      "pt-0"
                                    ] : [
                                      "text-5xl small:text-4xl",
                                      "",
                                      "text-xs small:hidden",
                                      "pt-10-px"
                                    ];
                                  return JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: code,
                                                      className: match$2[0]
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: Csat$ReactHooksTemplate.answerTypeToString(csat, xs, SurveyLanguage$ReactHooksTemplate.name(language)),
                                                      className: match$2[2]
                                                    })
                                              ],
                                              className: "animated " + match$2[1] + " flex flex-col items-center\n                  focus:outline-none " + match$2[3],
                                              onClick: (function (param) {
                                                  Curry._1(onChange, Csat$ReactHooksTemplate.setAnswer(csat, xs));
                                                })
                                            }, String(id));
                                }))),
                      className: "flex w-full justify-between items-start pb-5"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col py-8 px-16 small:px-6"
            });
}

var make = CsatForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
